import { useQuery } from "@tanstack/react-query";
import { toast } from "react-toastify";
import egam from "../../services/egam";
import { getClientData } from "../../services/auth";
import { queryKeys } from "../api/queryKeys";
import {
  ParcelamentoNormalParams,
  ParcelamentoNormalResponse,
} from "../../types/Parcelamento";

export const useParcelamentoNormal = (
  params?: ParcelamentoNormalParams,
  enabled: boolean = true
) => {
  return useQuery<ParcelamentoNormalResponse>({
    queryKey: queryKeys.parcelamentoNormal(params),
    queryFn: async () => {
      if (!params) {
        throw new Error("Parâmetros não fornecidos");
      }

      const { totalLiquido, totalMedicamentos, totalPerfumaria, minimum } =
        params;

      if (totalLiquido < minimum) {
        return { parcelas: [] };
      }

      const clientData = getClientData();
      if (!clientData) {
        throw new Error("Cliente não autenticado");
      }

      const formData = new FormData();
      formData.append("pedidoExterno", "true");
      formData.append("totalLiquido", totalLiquido.toFixed(2));
      formData.append("totalMedicamentos", totalMedicamentos.toFixed(2));
      formData.append("totalPerfumaria", totalPerfumaria.toFixed(2));

      const response = await egam.post<ParcelamentoNormalResponse>(
        "pedidos/finalizar/parcelamento",
        formData
      );

      if (response.data && response.data.msg_err) {
        const errorMsg = String(response.data.msg_err);
        toast.error(errorMsg);
        throw new Error(errorMsg);
      } else if (response.data && response.data.parcelas === null) {
        const errorMsg = "Ocorreu um erro ao buscar as opções de parcelamento.";
        toast.error(errorMsg);
        throw new Error(errorMsg);
      }

      return response.data;
    },
    enabled:
      enabled && params !== undefined && params.totalLiquido >= params.minimum,
    staleTime: 0, // Sempre refetch quando os parâmetros mudarem (totais mudam frequentemente)
    refetchOnMount: "always", // Sempre refetch quando o componente montar
  });
};
